jQuery(function ($) {

    $('#section-headline> * > article:first-child').addClass('active');

    var pagetop = $('btn-top');
    pagetop.hide();
    $(window).scroll(function () {
       if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
       } else {
            pagetop.fadeOut();
       }
    });
    pagetop.click(function () {
       $('body, html').animate({ scrollTop: 0 }, 500);
       return false;
    });



    $(function () {
      const header = $('#main-nav');
      $(window).scroll(function () {
        if ($(this).scrollTop() >= 60) {
          header.addClass('shadow');
        } else {
          header.removeClass('shadow');
        }
      });
    });

    $('.fadeInUpTrigger').one('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('animate__animated animate__fadeInUp animate_slower');
      }
    });
    

    $(window).load(function() {
      $('#slider').flexslider({
        controlsConatiner: '.flexslider-controls',
        manualControls: ".flexslider-controls .slides li",
        mode: 'horizontal',
        nextText: '',
        prevText: ''
      });
    });

});
